import React, { FC } from "react";
import { useSelector } from "react-redux";
import TableTab from "../components/tabs/table-tab";
import { ACCESS_PROFILE } from "../constants/menu-types";
import { useLocale } from "../contexts/localeContext";
import { TableContextProvider } from "../contexts/table/TableContextProvider";
import TableContextStateMonitor from "../contexts/table/TableContextStateMonitor";
import { TranslationKeys } from "../contexts/TranslationKeys";
import { Category } from "../models/Category";
import AccessProfileColumn from "../models/ColumnDefinitions/AccessProfileColumn";
import AccessProfileSearch from "../models/search/AccessProfileSearch";
import { DeleteEntityResult } from "../models/services/DeleteEntityResult";
import { deleteAccessProfile, getAllAccessProfiles } from "../services/accessProfileService";

interface Props {
    setBusy: (isBusy: boolean) => void,
    categories: Category[],
    setCategories: (category: Category[]) => void,
    onFilterChange?: (filter: any) => void,
    setShowAccessProfileWizard: React.Dispatch<React.SetStateAction<boolean>>;
}

const AccessProfilesTab: FC<Props> = ({ setBusy, categories, setCategories, onFilterChange, setShowAccessProfileWizard }) => {
    const itemPath = '/access-control/enrolment/access-profile/';
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.accessProfiles)  
    const userLoginId = useSelector((state: any) => (state.userInfo.id)) 
    
    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusy(true);

        return new Promise((resolve, reject) => {
            deleteAccessProfile(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        setCategories([{ ...categories[0], count: (categories[0]?.count ?? 1) - 1 }]);
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
        });
    }

    const initialiseUserPreferences = (setDetails: (userLoginId, ACCESS_PROFILE) => void) => {
        setDetails(userLoginId, ACCESS_PROFILE);
    }

    return <TableContextProvider
        dataMethod={getAllAccessProfiles}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={AccessProfileColumn}
        searchDescriptor={AccessProfileSearch}
        useTable
        usePagination
        useFilter
        useSearch
        useSort
        deleteMethod={onDelete}>
        <TableContextStateMonitor onFilterChange={onFilterChange} />
        <TableTab
            title={title}
            selectRows={false}
            rowPath={itemPath} 
            setShowModal={() => setShowAccessProfileWizard(true)}
            cyName="accessProfile"/>
    </TableContextProvider>;
};

export default AccessProfilesTab;
